<template>
  <div class="Copyright">
    <span>技术支持：
      <a href="https://www.tyxwl.com/">贵州天逸轩网络科技有限公司</a>
    </span>
  </div>
</template>
<script>
export default {
  name: 'CopyRight',
  data() {
    return {
      Height: 0
    }
  },
  mounted() {
    // this.getHeight()
    if (document.body.scrollHeight < document.documentElement.clientHeight) {
      this.Height = document.documentElement.clientHeight -516
      window.onresize = () => {
        this.Height = document.documentElement.clientHeight -516
      }
    } //监听浏览器窗口变化
  }
}
</script>
<style lang="scss" scoped>
.Copyright {
  position: fixed;
  width: 100%;
  margin-top: 100px;
  background-color: #212121;
  height: 40px;
  line-height: 40px;
  padding: 10px 0;
  text-align: center;
  bottom: 0;
  z-index: 999;
  span {
    color: rgb(160, 155, 159);
    font-size: 14px;
    text-align: center;
    a {
      color: #409efe;
      font-size: 14px;
      text-decoration: none;
    }
  }
}
</style>
